
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputComponent from '../InputComponent';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';

import DropDownList from '../DropDownList';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';


import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';


import { getUIText, generateUid, getUniqueName } from '../../utils/index';

import { MEDIUMS } from '../../modules/data/mediums';

const GAS = 'GAS';
const LIQUID = 'LIQUID';
const SOLID = 'SOLID';

const defaultItem = {
  'custom': 'true',
  'name': '',
  'Density': 0,
  'Heat-capasity': 0,
  'Temperature': 100,
  'Freezing-temperature': -300,
  'Type-of-medium': GAS,
};

class Medium extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...defaultItem,
      id: null,
    };
  }

  onCreateNewItem() {
    const { translations, app, create, items} = this.props;

    const newItem = {
      ...defaultItem,
      name: getUniqueName(items, getUIText('SETTINGS-CUSTOM_MEDIUM_HEADER', app.language, translations)),
      Nid: generateUid()
    };

    this.setState({
      id: newItem.Nid
    });

    create({item: newItem, type: MEDIUMS});
  }

  onDeleteItem(id, e) {
    const { items, remove } = this.props;
    if(items) {
      const index = items.findIndex( (item ) => {
        if(item.Nid === id) {
          return true;
        }
        return false;
      });

      const newItems = [
        ...items.slice(0, index),
        ...items.slice(index + 1)
      ];

      let newId = '-1';
      if(newItems[index]) {
        newId = newItems[index].Nid;
      } else if (newItems[index - 1]) {
        newId = newItems[index - 1].Nid;
      }

      remove({id: items[index].Nid, type: MEDIUMS});
      this.setState({
        id: newId
      });
    }
  }

  onPatchItem(id, updateItem, e) {
    const { items, patch } = this.props;

    if(items) {
      const updatedItem = items.find( item => {
        if(item.id === id) {
          return true;
        }
        return false;
      });
      patch({item: updateItem, type: MEDIUMS});
    }
  }

  render() {
    const { translations, app, items} = this.props;

    let data = [];
    if(items) {
      data = items.filter( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return true;
        }
      });
    }

    data = data.map( item => {
      return {...item, id: item.Nid};
    });

    const selectedItem = data.find( (item) => {
      if(item.Nid === this.state.id) {
        return true;
      }
      return false;
    });

    return (
      <div className="settings-product">
        <Grid container spacing={8}>
          <Grid item xs={6} className="setting-dropdownlist-container">
            <DropDownList
              className="setting"
              data={data}
              selectedItem={this.state.id}
              label={getUIText('SETTINGS-CUSTOM_MEDIUMS', app.language, translations)}
              onChange={ (id) => {this.setState({id: id});} } />
          </Grid>
          <Grid item xs={6} className="setting-dropdownlist-container">
            <div className="settings-buttons" >
              <Button color="primary" onClick={this.onCreateNewItem.bind(this)} >{getUIText('GENERAL-NEW', app.language, translations)}</Button>
              <Button color="primary" disabled={this.state.id ? false : true} onClick={this.onDeleteItem.bind(this, this.state.id)} >{getUIText('GENERAL-DELETE', app.language, translations)}</Button>
            </div>
          </Grid>
          {selectedItem ? <Grid item xs={12} md={6}>
            <InputComponent
              label={getUIText('SETTINGS-PRODUCT_NAME', app.language, translations)}
              value={selectedItem ? selectedItem['name'] : ''}
              type="string"
              className="full-width settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'name': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-DENSITY', app.language, translations)}
              value={selectedItem ? selectedItem['Density'] : ''}
              type="number"
              unit="kg/m³"
              className="settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Density': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-HEAT_CAPACITY', app.language, translations)}
              value={selectedItem ? selectedItem['Heat-capasity'] : ''}
              type="number"
              unit="kJ/kgK"
              className="settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Heat-capasity': value})}
              />
          </Grid> : null }
          {selectedItem ? <Grid item xs={12} md={6}>
            <InputComponent
              label={getUIText('SETTINGS-TEMPERATURE', app.language, translations)}
              value={selectedItem ? selectedItem['Temperature'] : ''}
              type="number"
              unit="°C"
              className="settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Temperature': value})}
              />

            <InputComponent
              label={getUIText('SETTINGS-FREEZING_TEMPERATURE', app.language, translations)}
              value={selectedItem ? selectedItem['Freezing-temperature'] : ''}
              type="number"
              unit="°C"
              className="settings-margin"
              onChange={(value) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Freezing-temperature': value})}
              />
          </Grid> : null }
          {selectedItem ? <Grid item xs={12}>

          <FormControl component="fieldset" required>
            <RadioGroup
              style={{flexDirection: 'row'}}
              value={selectedItem ? selectedItem['Type-of-medium'] : ''}
              onChange={(e) => this.onPatchItem(selectedItem.id, {...selectedItem, 'Type-of-medium': e.target.value})}
            >
              <FormControlLabel value={GAS} control={<Radio />} label={getUIText('SETTINGS-GAS', app.language, translations)} />
              <FormControlLabel value={LIQUID} control={<Radio />} label={getUIText('SETTINGS-LIQUID', app.language, translations)} />
              <FormControlLabel value={SOLID} control={<Radio />} label={getUIText('SETTINGS-SOLID', app.language, translations)} />
            </RadioGroup>
          </FormControl>
          </Grid> : null }
        </Grid>
      </div>
    );
  }
}

Medium.propTypes = {

  translations: PropTypes.any,
  app: PropTypes.any,
  create: PropTypes.any,
  items: PropTypes.any,
  remove: PropTypes.any,
  patch: PropTypes.any,
};

export default Medium;
